module.exports = __webpack_public_path__ + "media/store/fonts/BeausiteClassic-Medium_web-eac81ed5903f801829101ed7a7bcd3bd.woff";